module.exports = __webpack_public_path__ + "static/media/upload-document.0eb096c0.svg";